import React, { useEffect, useState } from "react";

import { _common } from "../common";
import { ServerInterface } from "../ServerInterface";
const common = _common;

export default function Header(props: { noAvatar?: boolean }) {
  const { noAvatar } = props;

  const user = JSON.parse(common.getUserFromLocalStorage());
  const src = `${ServerInterface.serverUrl}/booking/profileImage/?memberId=${user.memberId}`;

  const [imageNotFound, setImageNotFound] = useState(false);
  const [imageSrc, setImageSrc] = useState<string>(src);

  // useEffect(() => {
  //   setImageSrc(src);
  //   setImageNotFound(false);
  // }, []);

  return (
    <div
      style={{
        backgroundColor: "#bbb",
        height: "140px",
        position: "relative",
        marginBottom: "20px",
        width: "100%",
        overflow: "hidden",
        display: "flex",
        fontSize: "min(calc(100vw / 25), 1.3em)",
      }}
    >
      <div
        style={{
          padding: "15px",
          width: "100px",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          flexShrink: 1
        }}
      >
        <img
          src="/images/Kreuzberg-Logo-600x600.jpg"
          style={{
            height: "auto",
            width: "100%",
            borderRadius: "100px",
            objectFit: "cover",
            boxShadow: "0 0 20px rgba(0, 0, 0, 0.75)",
          }}

          onClick={() => {
            window.location.href = "/login";
          }}
        />
      </div>


      <div style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        flexShrink: "1",
        flexGrow: "1",
        alignItems: "center",
        textAlign: "center",
        justifyContent: "center",
      }}>
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            textAlign: "center",
            paddingBottom: "5px",
            paddingTop: "5px",
            fontSize: "1.5em",
            fontWeight: "bolder",
            color: "darkgreen",
          }}
        >
          Platzreservierung
        </div>

        <div style={{ color: "white", textAlign: "center", fontSize: "0.8em", lineHeight: "1.1em" }}>
          TC Grün-Weiss <br />
          Am Kreuzberg e.V.
        </div>

        <div
          id="user"
          style={{
            left: "0px",
            fontSize: "1.2em",
            fontWeight: "bolder",
            color: "darkgreen",
            paddingTop: "5px",
            bottom: "0px",
            width: "100%",
          }}
        >
          {common.user?.firstName && (
            <div style={{ textAlign: "center", display: "flex", flexDirection: "column" }}>
              <div> Hallo {common.user?.firstName} </div>
            </div>
          )}
        </div>
      </div>


      {!noAvatar && (
        <div
          style={{
            padding: "10px",
            width: "100px",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            flexShrink: 1
          }}
        >
          <img
            crossOrigin="anonymous"
            key={`f-${imageNotFound}`}
            src={imageNotFound ? "images/gost.png" : src}
            style={{
              height: "auto",
              width: "100%",
              borderRadius: "100px",
              objectFit: "cover",
              boxShadow: "0 0 20px rgba(0, 0, 0, 0.75)",
              // border: "1px solid white",
            }}
            onError={(ex) => {
              console.error("profileImage", ex);
              setImageNotFound(true);
            }}
            onClick={() => {
              window.location.href = "/profile?edit";
            }}
          />
        </div>
      )}

    </div>
  );
}
